<template>
  <v-container class="pt-0 mt-0">
    <!-- <date-range-selector class="pb-0 pt-0 mb-0 pt-0" /> -->
    <v-row justify="end" class="mb-0 pb-0">
      <v-col class="mb-0 pb-0">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeText"
              label="Date range"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
              :hide-details="hide_details"
            ></v-text-field>
          </template>
          <v-date-picker v-model="dates" range no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="loadData()">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-spacer class="mb-0 pb-0"></v-spacer>
      <v-col class="d-flex justify-end pt-6 mb-0 pb-0">
        <v-btn-toggle
          tile
          color="primary"
          group
          mandatory
          v-model="date_toggle"
        >
          <v-btn value="30_days" small @click="set30Days()">
            30 Days
          </v-btn>
          <v-btn value="this_month" small @click="setThisMonth()">
            This Month
          </v-btn>
          <v-btn value="7_days" small @click="set7Days()">
            7 Days
          </v-btn>
          <v-btn value="this_week" small @click="setThisWeek()">
            This Week
          </v-btn>
          <v-btn value="yesterday" small @click="setYesterday()">
            Yesterday
          </v-btn>
          <!-- <v-btn value="justify" small>
            Today
          </v-btn> -->
        </v-btn-toggle>
      </v-col>
    </v-row>
    <dashboard-cards v-bind:card_data="card_data"></dashboard-cards>
    <!-- <attendance-chart v-bind:attendances="attendances" class="pb-0 mb-0" /> -->
    <v-row>
      <v-col md="4">
        <top-5-list
          mode="On-Time"
          :list_data="top5.on_time"
          :loading="top5.on_time_loading"
        ></top-5-list>
      </v-col>
      <v-col md="4">
        <top-5-list
          mode="Late"
          :list_data="top5.late"
          :loading="top5.late_loading"
        ></top-5-list>
      </v-col>
      <v-col md="4">
        <top-5-list
          mode="Absent"
          :list_data="top5.absent"
          :loading="top5.absent_loading"
        ></top-5-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import DateRangeSelector from "../components/DateRangeSelector";
import DashboardCards from "@/views/Dashboard/components/DashboardCards";
// import AttendanceChart from "@/views/Dashboard/components/AttendanceChart";
import Top5List from "@/views/Dashboard/components/Top5List";
// import PerformanceChart from "../components/PerformanceChart";
import axios from "axios";
import moment from "moment";
export default {
  name: "dashboard",
  components: {
    // DateRangeSelector,
    DashboardCards,
    // AttendanceChart,
    Top5List,
    // PerformanceChart
  },
  data() {
    return {
      company_id: this.$store.state.company,
      menu: false,
      date_toggle: "this_month",
      hide_details: true,
      dates: ["2020-03-01", "2020-03-31"],
      transfomed_dates: [],
      card_data: {},
      attendances: [],
      top5: {
        on_time: [],
        on_time_loading: true,
        late: [],
        late_loading: true,
        absent: [],
        absent_loading: true,
      },
    };
  },
  methods: {
    loadData() {
      this.top5.on_time_loading = true;
      this.top5.late_loading = true;
      this.top5.absent_loading = true;
      this.menu = false;
      this.getDashboardCardsData();
      this.getAttendanceChartData();
      this.getTop5Data("On-Time");
      this.getTop5Data("Late");
      this.getTop5Data("Absent");
    },
    set30Days() {
      this.dates = [];
      const date_now = moment()
        .format("YYYY-MM-DD");
      const date_month_start = moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD");
      this.dates.push(date_month_start, date_now);
      this.loadData();
    },
    setThisMonth() {
      this.dates = [];
      const date_now = moment()
        .format("YYYY-MM-DD");
      const date_month_start = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.dates.push(date_month_start, date_now);
      this.loadData();
    },
    set7Days() {
      this.dates = [];
      const date_now = moment()
        .format("YYYY-MM-DD");
      const date_month_start = moment()
        .subtract(1, "week")
        .format("YYYY-MM-DD");
      this.dates.push(date_month_start, date_now);
      this.loadData();
    },
    setThisWeek() {
      this.dates = [];
      const date_now = moment()
        .format("YYYY-MM-DD");
      const date_month_start = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      this.dates.push(date_month_start, date_now);
      this.loadData();
    },
    setYesterday() {
      this.dates = [];
      const date_now = moment()
        .format("YYYY-MM-DD");
      const date_month_start = moment()
        .subtract(1, "day")
        .format("YYYY-MM-DD");
      this.dates.push(date_month_start, date_now);
      this.loadData();
    },
    getDashboardCardsData() {
      const url =
        `https://us-central1-appsensi-dev.cloudfunctions.net/getCompanySummary?company_id=${this.company_id}&date_start='` +
        this.transformedDates[0] +
        "'&date_end='" +
        this.transformedDates[1] +
        "'";
      axios.get(url).then((res) => {
        this.card_data = res.data.result;
      });
    },
    getAttendanceChartData() {
      const url =
        `https://us-central1-appsensi-dev.cloudfunctions.net/getCompanyAttendances?company_id=${this.company_id}&date_start='` +
        this.transformedDates[0] +
        "'&date_end='" +
        this.transformedDates[1] +
        "'";
      axios.get(url).then((res) => {
        this.attendances = {
          dates: res.data.result.dates,
          data: res.data.result.attendances,
        };
      });
    },
    getTop5Data(mode) {
      const url =
        `https://us-central1-appsensi-dev.cloudfunctions.net/getTop5?company_id=${this.company_id}&date_start='` +
        this.transformedDates[0] +
        "'&date_end='" +
        this.transformedDates[1] +
        "'&mode=" +
        mode;
      axios
        .get(url)
        .then((res) => {
          if (mode === "On-Time") {
            this.top5.on_time = res.data.result;
            this.top5.on_time_loading = false;
          } else if (mode === "Late") {
            this.top5.late = res.data.result;
            this.top5.late_loading = false;
          } else if (mode === "Absent") {
            this.top5.absent = res.data.result;
            this.top5.absent_loading = false;
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        });
    },
  },
  computed: {
    dateRangeText() {
      return this.transformedDates.join(" to ");
    },
    transformedDates() {
      let transformed_dates = [];
      this.dates.forEach((date) => {
        let new_date = moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
        transformed_dates.push(new_date);
      });
      return transformed_dates;
    },
  },
  created() {
    this.setThisMonth();
  },
};
</script>
